import { render, staticRenderFns } from "./AffiliateDetailsLoader.vue?vue&type=template&id=c5fb1caa&"
import script from "./AffiliateDetailsLoader.vue?vue&type=script&lang=js&"
export * from "./AffiliateDetailsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports